export default __webpack_public_path__ + "static/media/download-icn.707027db.svg";